var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Arrow right"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("circle",{"id":"Oval-3","fill":"#50E3C2","cx":"15","cy":"15","r":"15","key":3}),React.createElement("polygon",{"id":"Triangle","fill":"#FFFFFF","transform":"translate(16.754506, 15.000000) rotate(-90.000000) translate(-16.754506, -15.000000) ","points":"16.7545064 19.2454936 10.3735114 10.7545064 23.1355013 10.7545064","key":4})]);
}

ArrowRight.defaultProps = {"width":"30px","height":"30px","viewBox":"0 0 30 30","version":"1.1"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
